import { StoreSchema } from '../../types/store'
import { createSelector } from 'reselect'

export const selectConfigChangeHistoryLoading = (store: StoreSchema) =>
    store.configChangesHistory.isLoading

export const selectConfigChangeHistory = (store: StoreSchema) =>
    store.configChangesHistory.productConfigChangeHistory

export const selectConfigChangeHistoryRecords = (store: StoreSchema) =>
    store.configChangesHistory.productConfigChangeHistory.update_history

export const selectFrom = (store: StoreSchema) =>
    store.configChangesHistory.from

export const selectTo = (store: StoreSchema) => store.configChangesHistory.to

export const selectLogin = (store: StoreSchema) =>
    store.configChangesHistory.login

export const selectStatus = (store: StoreSchema) =>
    store.configChangesHistory.status

export const selectPage = (store: StoreSchema) =>
    store.configChangesHistory.page

export const selectLimit = (store: StoreSchema) =>
    store.configChangesHistory.limit

export const selectFilterFields = createSelector(
    [selectFrom, selectTo, selectLogin, selectStatus, selectPage, selectLimit],
    (from, to, login, status, page, limit) => ({
        from,
        to,
        login,
        status,
        page,
        limit,
    })
)
